/**
 * Extracted from `components/grading/submission-identity-markers.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import { StatusBadge } from "@/components/ui/status-badge"
import type { SubmissionScoringStatus } from "@/lib/exam-status-badges"
import { submissionScoringStatusChip } from "@/lib/exam-status-badges"
import {
  submissionQuestionCompletion,
  type AssessmentGradingState,
  type GradingSubmission,
} from "@/lib/mock/exam-grading"

export function submissionCompactNumber(
  row: GradingSubmission,
  index: number,
): number {
  const fromLabel = row.maskLabel.match(/#(\d+)/)?.[1]
  if (fromLabel) return Number.parseInt(fromLabel, 10)
  return index + 1
}

export function hubSubmissionScoringStatus(
  row: GradingSubmission,
): SubmissionScoringStatus {
  if (row.thrownOut) return "Discarded"
  switch (row.scoreStatus) {
    case "Scores Released":
      return "Score Released"
    case "Graded":
      return "Scored"
    case "Partially Evaluated":
      return "Partially scored"
    default:
      return "Unscored"
  }
}

export function submissionRosterStatusBadge(
  state: AssessmentGradingState,
  row: GradingSubmission,
) {
  const status = hubSubmissionScoringStatus(row)
  if (status === "Scored" || status === "Score Released") {
    const { scoredCount, totalCount } = submissionQuestionCompletion(state, row)
    return (
      <StatusBadge
        label={`${scoredCount}/${totalCount}`}
        tone={status === "Score Released" ? "info" : "success"}
        icon="fa-circle-check"
        size="sm"
      />
    )
  }
  return submissionScoringStatusChip(status, "sm")
}
